import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mutate", "title", "noAppsTitle", "headingLevel", "context", "actionBus"];
import React from 'react';
import { deriveMutateOfChild } from '@atlassian/surface-sdk/utils';
import { AppRecommendationsSectionHeader } from '../app-recommendation-section-header';
import { AppRecommendationsList } from '../app-recommendations-list';
export var AppRecommendationsWithTitle = function AppRecommendationsWithTitle(_ref) {
  var mutate = _ref.mutate,
    title = _ref.title,
    noAppsTitle = _ref.noAppsTitle,
    headingLevel = _ref.headingLevel,
    context = _ref.context,
    actionBus = _ref.actionBus,
    rest = _objectWithoutProperties(_ref, _excluded);
  var AppRecommendationSectionHeaderMutate = deriveMutateOfChild({
    mutate: mutate,
    mutationArgs: {
      noAppsTitle: noAppsTitle,
      title: title,
      headingLevel: headingLevel
    }
  });
  var AppRecommendationsMutate = deriveMutateOfChild({
    mutate: mutate,
    mutationArgs: rest
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppRecommendationsSectionHeader, {
    title: title,
    noAppsTitle: noAppsTitle,
    mutate: AppRecommendationSectionHeaderMutate,
    context: context,
    headingLevel: headingLevel,
    actionBus: actionBus
  }), /*#__PURE__*/React.createElement(AppRecommendationsList, _extends({}, rest, {
    actionBus: actionBus,
    context: context,
    mutate: AppRecommendationsMutate
  })));
};